import {
  Collapse,
  Table,
  TableBody,
  TableContainer,
  TableRow,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Expense } from "../entriesAPI";
import { CustomEntriesTableCell } from "../styles";
import { Refs } from "../types";

const EntriesCollapsibleTable = ({
  open,
  items,
  headers,
  refs,
}: {
  open: boolean;
  items: { [key: string]: Expense };
  headers: string[];
  refs: Refs<any[]>;
}) => {
  const [columnWidths, setColumnWidths] = useState<number[]>([]);
  const { t } = useTranslation("common");

  const formattedValues = headers.map((key) => {
    // Find all items with the same expenseTypeCode
    const matchedItems = Object.values(items).filter(
      (item) => item.expenseTypeCode === key,
    );

    if (matchedItems.length > 0) {
      // Calculate the sum of amounts for matched items
      const totalAmount = matchedItems.reduce((sum, item) => {
        const itemAmount = parseFloat(item.amount || "0");
        return sum + itemAmount;
      }, 0);

      // Format the total amount
      const formattedAmount =
        totalAmount % 1 === 0 ? totalAmount.toFixed(0) : totalAmount.toFixed(2);

      return { [key]: `${formattedAmount}${matchedItems[0].unit || ""}` };
    } else {
      return { [key]: "" };
    }
  });

  const values = formattedValues.flatMap((item: object) => Object.values(item));

  useEffect(() => {
    if (refs?.current && open) {
      const widths = refs.current.map(
        (element) => element?.getBoundingClientRect().width,
      );
      setColumnWidths(widths);
    }
  }, [refs, open]);

  return (
    <Collapse
      sx={{
        ".MuiCollapse-wrapper": {
          display: "block",
        },
      }}
      timeout={{ exit: 0, enter: 0 }}
      in={open}
      unmountOnExit
      orientation="horizontal"
    >
      <TableContainer sx={{ overflow: "hidden" }}>
        <Table>
          <TableBody>
            <TableRow>
              {values.map((expense, index) => {
                return expense ? (
                  <CustomEntriesTableCell
                    sx={{ height: "63px" }} // TODO: inherit height?
                    key={index}
                    borderLeft={index !== 0}
                    align="center"
                    width={`${columnWidths[index]}`}
                  >
                    {expense}
                  </CustomEntriesTableCell>
                ) : (
                  <CustomEntriesTableCell
                    sx={{ height: "63px" }}
                    key={index}
                    width={`${columnWidths[index]}`}
                  />
                );
              })}
              {!values.length && (
                <CustomEntriesTableCell
                  sx={{ visibility: "hidden", height: "63px" }}
                  colSpan={headers.length}
                >
                  {t("common:noSelection")}
                </CustomEntriesTableCell>
              )}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Collapse>
  );
};

export default EntriesCollapsibleTable;
